//constants.js
// World
export const WORLD = { w: 5000, h: 2000 };
export const WORLD_ORIGIN = { x: -WORLD.w / 2, y: -WORLD.h / 2 };

// 마우스오버 이동값
export const HOVER_MOVES = {
  '0막': [
    ['0막', -200, -20],
    ['1막', 20, 0],
  ],
  '1막': [
    ['1막', -120, 70],
    ['3막', 80, -50],
  ],
  '2-1막': [
    ['0막', -100, -10],
    ['2-1막', 70, 80],
  ],
  '2-2막': [
    ['1막', 0, -60],
    ['2-2막', 60, 70],
  ],
  '3막': [
    ['3막', -180, 120],
    ['4-1막', 100, -20],
  ],
  '4-1막': [
    ['4-1막', -120, 20],
    ['4-2막', 200, 20],
  ],
  '4-2막': [['4-2막', 380, 80]],
  '5-1막': [['5-1막', 180, 150]],
  '5-2막': [
    ['4-2막', 90, -90],
    ['5-2막', -180, 50],
  ],
};

// 그래디언트 위치 오프셋
export const GRAD_OFFSETS = [
  { x: 230, y: 45 },
  { x: 240, y: 95 },
  { x: 185, y: 1195 },
  { x: 990, y: 770 },
  { x: 1980, y: 885 },
  { x: 2980, y: 785 },
  { x: 675, y: 610 },
];

// 프리로더 애니메이션 속도 관리
export const PRELOADER = {
  GRAD_INTERVAL: 0.5,
  GRAD_FADE_SPEED: 2,
  GRAD_OUT_SPEED: 3,
  PIECE_IN_SPEED: 3,
};

// 메인
export const MAIN = {
  SCENE_IN_SPEED: 2,
};

// 줌
export const INPUT = {
  MIN_SCALE: 0.2,
  MAX_SCALE: 2.5,
  ZOOM_SPEED: 0.0015,
};

// 카메라
export const CAMERA = {
  ALLOW_FACTOR: 1.5,
  DEFAULT: { x: 0, y: 0, scale: 0.4 },

  MOVE_SPEED: 3,
  ZOOM_STEP: 1.5,
  ZOOM_SPEED: 6,

  REVEAL_ZOOM_FACTOR: 2.0,
};

// 사운드
export const SOUND = {
  // 0막 앰비언스
  BASE_MIN: 0.1,
  BASE_MAX: 1,
  BASE_RADIUS: 900,

  // 나머지 막 레이어 반경
  LAYER_RADIUS: 650,

  // 볼륨 변화 부드럽게
  SMOOTH_SPEED: 8,

  // 각 막 사운드 파일 맵
  SOURCES: {
    '0막': '/sounds/stage0.mp3',
    '1막': '/sounds/stage1.mp3',
    '2-1막': '/sounds/stage2-1.mp3',
    '2-2막': '/sounds/stage2-2.mp3',
    '3막': '/sounds/stage3.mp3',
    '4-1막': '/sounds/stage4-1.mp3',
    '4-2막': '/sounds/stage4-2.mp3',
    '5-1막': '/sounds/stage5-1.mp3',
    '5-2막': '/sounds/stage5-2.mp3',
  },
};

export const POINT = {
  HIT_RADIUS: 33,
  SWAP_ON: 0.9,
  SWAP_OFF: 0.85,
  FADE_SPEED: 12,
  SCALE: 1,
};

export const STAGE_CLASS_MAP = {
  '1막': 'stage-1',
  '2-1막': 'stage-2',
  '2-2막': 'stage-2-2',
  '3막': 'stage-3',
  '4-1막': 'stage-4',
  '4-2막': 'stage-4',
  '5-1막': 'stage-5',
  '5-2막': 'stage-5',
};

export const STORY_META_MAP = {
  '0막': {
    titleParts: [{ text: '타인의 고장 ' }, { text: '2025', italic: true }],
    tag: null,
  },
  '0막-영상': {
    title: '[타인의 고장 - 기록]',
    tag: null,
  },
  '1막': {
    title: '[바람이 머무는 마을, 삶을 품다]',
    tag: '전여울',
  },
  '2-1막': {
    title: '[타인의 고장 - 인터뷰]',
    tag: null,
  },
  '2-2막': {
    title: '[겹과 겹]',
    tag: '호이요',
  },
  '3막': {
    title: '[바람의 무보]',
    tag: '소리골남도',
  },
  '4-1막': {
    titleParts: [
      { text: '[고장마을 :', br: true },
      { text: '곡식처럼 인연이 영그는 곳]' },
    ],
    tag: '전여울',
  },
  '4-2막': {
    title: '[서씨 이야기]',
    tag: '소리골남도',
  },
  '5-1막': {
    title: '[the 3rd Landscape]',
    tag: null,
  },
  '5-2막': {
    title: '[ 전시 《타인의 고장 — 옮아가기》 ]',
    tag: null,
  },
};

export const STORY_STAGE_META = {
  '0막': { opens: ['0막', '0막-영상'] },
  '1막': { opens: ['1막'] },
  '2-1막': { opens: ['2-1막', '2-2막'] },
  '2-2막': { opens: ['2-1막', '2-2막'] },
  '3막': { opens: ['3막'] },
  '4-1막': { opens: ['4-1막', '4-2막'] },
  '4-2막': { opens: ['4-1막', '4-2막'] },
  '5-1막': { opens: ['5-1막', '5-2막'] },
  '5-2막': { opens: ['5-1막', '5-2막'] },
};

export const BOOK_PAGES = {
  0: [
    '/images/book1-1.webp',
    '/images/book1-2.webp',
    '/images/book1-3.webp',
    '/images/book1-4.webp',
    '/images/book1-5.webp',
    '/images/book1-6.webp',
  ],
  1: [
    '/images/book2-1.webp',
    '/images/book2-2.webp',
    '/images/book2-3.webp',
    '/images/book2-4.webp',
    '/images/book2-5.webp',
    '/images/book2-6.webp',
  ],
  2: [
    '/images/book3-1.webp',
    '/images/book3-2.webp',
    '/images/book3-3.webp',
    '/images/book3-4.webp',
    '/images/book3-5.webp',
    '/images/book3-6.webp',
  ],
  3: [
    '/images/book4-1.webp',
    '/images/book4-2.webp',
    '/images/book4-3.webp',
    '/images/book4-4.webp',
    '/images/book4-5.webp',
    '/images/book4-6.webp',
  ],
};

export const BOOK_AUDIO = {
  0: '/sounds/book1.mp3',
  1: '/sounds/book2.mp3',
  2: '/sounds/book3.mp3',
  3: '/sounds/book4.mp3',
};

export const STAGE22_AUDIO = 'https://cdn.tain-gozang.com/story2_2.mp3';

export const STAGE52_GALLERY_BASE = '/images/5-2';

export const STAGE52_GALLERY_ROW_COUNTS = [6, 15, 17];

export const STAGE52_GALLERY_CAPTIONS = {
  1: [
    {
      range: [1, 3],
      text: `전시장 전경. 
관객은 극장의 두 방향을 넘나든다. 무대를 향해 서는 몸과, 무대에서 관객석을 바라보는 몸이 서로 교차한다. 무대와 객석 사이를 오가는 시선과 발걸음으로, 타인과 나의 자리가 잠시 겹쳐지며 서로의 곁에 서 본다. 
`,
    },
    {
      range: [4, Infinity],
      text: '',
    },
  ],
  2: [
    {
      range: [1, Infinity],
      text: `호이요, <겹과 겹>, 2025
종이에 인쇄, 594x410mm
사운드, 겹1(15분), 겹2(4분 55초), 겹3(4분 3초), 겹4(3분 59초), 루프

호이요는 고장마을을 거닐며 만난 소리와 질감, 접촉의 순간들을 모아 ‘지도’를 그린다. 관객은 바닥 위 선과 소리를 따라 <겹과 겹>으로 표현된 마을을 마주한다.`,
    },
  ],
  3: [
    {
      range: [1, 3],
      text: `전여울, <고장마을 - 곡식처럼 인연이 영그는 곳>, 2025
<바람이 머무는 마을, 삶을 품다>, 2025`,
    },
    {
      range: [4, Infinity],
      text: `이안, <바람과 바람들>, 2025
다채널 비디오, 스테레오 사운드, 1(3분 24초), 2(2분 12초), 3(3분 7초), 루프

고장마을의 설립 유래에 대한 마을 어르신의 기억과, 이 유래를 해석한 소리골남도의 퍼포먼스를 영상·소리가 분리된 형태로 보여준다. 과거와 현재의 파편이 서로 엮이며 ‘이야기가 시작되는 순간’을 드러낸다.`,
    },
  ],
};
